var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9779 9.09542L2.19583 17.8775M11.9193 2.19778C13.0453 2.9449 14.1275 3.82572 15.1389 4.83704C16.1589 5.85707 17.0462 6.94927 17.7974 8.08571M7.51586 6.22613L4.85826 5.34026C4.55219 5.23824 4.21508 5.30316 3.9688 5.51155L1.32757 7.74644C0.786849 8.20397 0.94047 9.07469 1.60512 9.31956L4.10772 10.2416M9.7586 15.8923L10.6806 18.3949C10.9255 19.0595 11.7962 19.2132 12.2537 18.6724L14.4886 16.0312C14.697 15.7849 14.7619 15.4478 14.6599 15.1417L13.774 12.4841M16.8467 1.02585L12.311 1.78179C11.8212 1.86342 11.372 2.10414 11.0328 2.46674L4.91952 9.00164C3.33491 10.6955 3.37898 13.3408 5.01915 14.981C6.65931 16.6212 9.30463 16.6653 10.9985 15.0806L17.5334 8.96735C17.896 8.62815 18.1367 8.17892 18.2184 7.68916L18.9743 3.15349C19.1829 1.90215 18.098 0.817289 16.8467 1.02585Z",
    stroke: "#565656",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.485552ff4a31ecfd192f732091295d8e.svg";
export { ForwardRef as ReactComponent };